import { InjectionToken } from '@angular/core';

/** The dropdown's own chrome strings, apart from the items a consumer passes in. */
export interface DropdownTexts {
  readonly placeholder: string;
  readonly allSelected: string;
  readonly countSelected: (count: number) => string;
  readonly selectAll: string;
  readonly deselectAll: string;
  readonly searchPlaceholder: string;
}

// Module level so $localize resolves once per bundle rather than per component instance.
const LOCALIZED_DROPDOWN_TEXTS: DropdownTexts = {
  placeholder: $localize`:@@dropdown.placeholder:Välj...`,
  allSelected: $localize`:@@dropdown.allSelected:Alla valda`,
  countSelected: (count) => $localize`:@@dropdown.countSelected:${count}:count: valda`,
  selectAll: $localize`:@@dropdown.selectAll:Markera alla`,
  deselectAll: $localize`:@@dropdown.deselectAll:Avmarkera alla`,
  searchPlaceholder: $localize`:@@dropdown.searchPlaceholder:Sök...`,
};

/**
 * Consumer-site pages get the market's translation through $localize; a route tree in
 * another language, such as the English portal, provides its own value.
 */
export const DROPDOWN_TEXTS = new InjectionToken<DropdownTexts>('DROPDOWN_TEXTS', {
  providedIn: 'root',
  factory: () => LOCALIZED_DROPDOWN_TEXTS,
});
